<template>
  <div class="value-filter">
    <div class="card-stack">
      <b class="price-range">Price range</b>
      <div class="modal-dialogue">
        <div class="buttons12">
          <div class="range-slider-set">
            ${{ Number(priceSliderValue[0]) * 1000 }} - ${{
              Number(priceSliderValue[1]) * 1000
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="range-selector">
      <div class="graph">
        <div
          v-for="index in 81"
          :key="index + 19"
          :class="'graph-child-price graph-child-price' + (index + 19)"
        ></div>
      </div>
      <div style="width: 100%">
        <vue-slider
          style="
            padding: 0px 0px;
            width: 100%;
            height: 4px;
            display: flex;
            justify-content: center;
          "
          v-model="priceSliderValue"
          :dot-options="dotOptions"
          :order="false"
          :tooltip="'none'"
          :min="20"
          :max="100"
          @change="updateGraph"
          @drag-end="checkThumbPosition"
        >
          <template #dot="{ index }">
            <div v-if="index === 0 || index === 1" class="custom-slider-thumb">
              <img
                loading="lazy"
                alt=""
                src="../../assets/custom-slider-icon.svg"
              />
            </div>
          </template>
        </vue-slider>
        <div style="display: flex; justify-content: space-between">
          <span>$20K</span>
          <span>$100K</span>
        </div>
      </div>
    </div>
  </div>

  <div class="filters-text-container">
    <img class="separator-icon" alt="" src="../../assets/separator.svg" />
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

const props = defineProps({
  min: String,
  max: String,
});

const emits = defineEmits(["priceRangeValue"]);
const priceSliderValue = ref([props.min, props.max]);
const dotOptions = [{ disabled: false, strokeWidth: 1 }, { disabled: false }];

const updateGraph = (value) => {
  const minValue = Math.round(value[0]);
  const maxValue = Math.round(value[1]);

  priceSliderValue.value = [minValue, maxValue];
  if (props.min != minValue || props.max != maxValue) {
    emits("priceRangeValue", priceSliderValue);
  }

  // Resetting all graph colors to default gray
  const allGraphItems = document.querySelectorAll(".graph-child-price");
  allGraphItems.forEach((item) => {
    item.style.backgroundColor = "var(--gray-medium)";
  });

  // Marking graph items between min and max as blue
  for (let i = minValue; i <= maxValue; i++) {
    const graphChild = document.querySelector(`.graph-child-price${i}`);
    if (graphChild)
      graphChild.style.backgroundColor = "var(--primary-accent-base)";
  }
};
const checkThumbPosition = () => {
  // Check if min thumb crosses max thumb
  if (priceSliderValue.value[0] > priceSliderValue.value[1]) {
    // Adjust min thumb to be equal to max thumb
    priceSliderValue.value[0] = priceSliderValue.value[1] - 5;
    updateGraph(priceSliderValue.value);
  }
};

onMounted(() => {
  updateGraph(priceSliderValue.value);
});
</script>

<style scoped>
.filters-text-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: var(--gap-xl);

  .filters {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 27px;
    display: inline-block;
    min-width: 54px;
    font-weight: 700;
    text-align: left;
    color: #3b3b3b;
    font-size: 18px;
  }

  .separator-icon {
    align-self: stretch;
    position: relative;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    flex-shrink: 0;
  }
}

.custom-slider-thumb {
  position: relative;
  width: 14px;
  height: 14px;
  cursor: pointer;
  justify-content: center;
  display: flex;
}

.price-range {
  width: 80px;
  position: relative;
  letter-spacing: 0.02em;
  line-height: 24px;
  display: inline-block;
  flex-shrink: 0;
  font-weight: 700;
}
.range-slider-set {
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
  font-weight: 600;
}
.buttons12 {
  border-radius: var(--br-9xs);
  background-color: var(--white-light);
  border: 0.5px solid var(--primary-accent-base);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-10xs) var(--padding-4xs);
  white-space: nowrap;
}
.modal-dialogue {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.card-stack {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px var(--padding-105xl) 0px 0px;
  gap: var(--gap-3xs);
}

.city {
  height: 23px;
  width: 80px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
  flex-shrink: 0;
  font-weight: 700;
}
.div4 {
  align-self: stretch;
  width: auto;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
  font-weight: 600;
  display: inline-block;
}
.mpgmpge {
  height: 21px;
  width: 75px;
  position: relative;
  font-size: var(--paragraph-primary-medium-regular-size);
  line-height: 21px;
  display: flex;
  align-items: center;
}
.buttons7 {
  flex: 1;
  border-radius: var(--br-9xs);
  background-color: var(--white-light);
  border: 0.5px solid var(--primary-accent-base);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 15px;
  gap: var(--gap-4xs);
}
.buttons-wrapper {
  height: 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.city-parent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* padding: 0px var(--padding-105xl) 0px 0px; */
  gap: var(--gap-3xs);
}

.graph-child-price {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price1,
.graph-child-price26,
.graph-child-price51,
.graph-child-price76 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price2,
.graph-child-price27,
.graph-child-price52,
.graph-child-price77 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price3,
.graph-child-price28,
.graph-child-price53,
.graph-child-price78 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price4,
.graph-child-price29,
.graph-child-price54,
.graph-child-price79 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price5,
.graph-child-price30,
.graph-child-price55,
.graph-child-price80 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price6,
.graph-child-price31,
.graph-child-price56,
.graph-child-price81 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price7,
.graph-child-price32,
.graph-child-price57,
.graph-child-price82 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price8,
.graph-child-price33,
.graph-child-price58,
.graph-child-price83 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price9,
.graph-child-price34,
.graph-child-price59,
.graph-child-price84 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}
.graph-child-price10,
.graph-child-price35,
.graph-child-price60,
.graph-child-price85 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price11,
.graph-child-price36,
.graph-child-price61,
.graph-child-price86 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price12,
.graph-child-price37,
.graph-child-price62,
.graph-child-price87 {
  height: 21px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price13,
.graph-child-price38,
.graph-child-price63,
.graph-child-price88 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price14,
.graph-child-price39,
.graph-child-price64,
.graph-child-price89 {
  height: 30px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price15,
.graph-child-price40,
.graph-child-price65,
.graph-child-price90 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price16,
.graph-child-price41,
.graph-child-price66,
.graph-child-price91 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price17,
.graph-child-price42,
.graph-child-price67,
.graph-child-price92 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price18,
.graph-child-price43,
.graph-child-price68,
.graph-child-price93 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price19,
.graph-child-price44,
.graph-child-price69,
.graph-child-price94 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price20,
.graph-child-price45,
.graph-child-price70,
.graph-child-price95 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price21,
.graph-child-price46,
.graph-child-price71,
.graph-child-price96 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price22,
.graph-child-price47,
.graph-child-price72,
.graph-child-price97 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price23,
.graph-child-price48,
.graph-child-price73,
.graph-child-price98 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price24,
.graph-child-price49,
.graph-child-price74,
.graph-child-price99 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-price25,
.graph-child-price50,
.graph-child-price75,
.graph-child-price100 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-11xs);
  width: 100%;
}
.range-selector {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-6xs);
  box-sizing: border-box;
  max-width: 100%;
  text-align: center;
}
.value-filter {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-21xl);
  flex-shrink: 0;
  max-width: 100%;
  text-align: left;
  font-size: var(--paragraph-secondary-large-semibold-size);
  color: var(--black-default);
  font-family: var(--paragraph-secondary-large-semibold);
}
</style>
